import React from 'react'
import { AppAcrissAutocomplete } from '@components'
import { object, string } from 'yup'
import { useSignal, useComputed } from '@preact/signals-react'
import { useAppFormHandler } from '@hooks'
import { formData } from '@signals'


export default function AcrissSelector() {

	const { acriss, onAcrissChange, error } = useAppFormHandler('acriss', object({ acriss: string().required('Must provide an acriss code') }))

	const acrissOptions = useComputed(() => formData.value?.acrissOptions)
	const newAcriss = useSignal('')

	return <AppAcrissAutocomplete
		multiple={false}
		value={acriss || ''}
		error={error}
		onChange={e => {
			onAcrissChange(e.target.value)
			if (!e.target.value) {
				newAcriss.value = ''
			}
		}}
		onFinishAjax={options => formData.value = { acrissOptions: options, ...formData.value }}
		options={acrissOptions.value}
	/>
}